import { render, staticRenderFns } from "./BaseLayout.vue?vue&type=template&id=b17c27c0&scoped=true"
import script from "./BaseLayout.vue?vue&type=script&lang=js"
export * from "./BaseLayout.vue?vue&type=script&lang=js"
import style0 from "./BaseLayout.vue?vue&type=style&index=0&id=b17c27c0&prod&lang=less&scoped=true"
import style1 from "./BaseLayout.vue?vue&type=style&index=1&id=b17c27c0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../erp_vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b17c27c0",
  null
  
)

export default component.exports